export { registerDefaultClients } from "./defaultRegistrator";
